<template>
	<div class="cms-image" :class="imageClassName" @click="cmsImageClick">
		<el-image :src="src" :lazy="lazy" :fit="fit">
			<div slot="placeholder" class="image-slot">
				<!-- 努力加载中<span class="dot">...</span> -->
				<!--<img src="../img/defultImg.png" alt="" class="img-d" />-->
				<div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
			</div>
			<div slot="error">
				<!-- <i class="el-icon-picture-outline"></i>
				加载失败 -->
				<img src="../img/error.png" alt="" class="img-d" />
			</div>
		</el-image>
		<img src="../../assets/img/video-play.png" alt="" class="poster" v-if="poster === 'video'" />
		<slot></slot>
	</div>
</template>

<script>
	import '../less/image.css'
	export default {
		name: 'CmsImage',
		props: {
			src: {
				type: String,
				default: ''
			},
			lazy: {
				type: Boolean,
				default: false
			},
			fit: {
				type: String,
				default: 'cover'
			},
			// video image
			poster: {
				type: String,
				default: ''
			},
			radius: {
				type: Boolean,
				default: false
			},
			// scale
			animate: {
				type: String,
				default: ''
			}
		},
		computed: {
			imageClassName() {
				return [`cms-${this.poster}`, (this.radius ? ' cms-radius' : ''), this.animate ? ` cms-${this.animate}` :
					''
				];
			}
		},
		methods: {
			cmsImageClick(e) {
				this.$emit('click', e);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsImage.vue